import { Loader } from '@mantine/core';
import React, { forwardRef } from 'react';
import { generateButtonClassNames } from '@/DesignSystem/Helper';
import type { IButtonProps } from '@/DesignSystem/Model/DataModel';
const Button = forwardRef<HTMLElement, IButtonProps>(({
  as,
  beforeIcon,
  afterIcon,
  children,
  type,
  disabled,
  href,
  target,
  onClick,
  isLoading,
  iconButton,
  elementId,
  id,
  ariaLabel,
  ...props
}, ref) => {
  const Component = as ?? `button`;
  const componentProps = {
    type,
    href,
    target,
    onClick,
    disabled,
    id: elementId,
    className: generateButtonClassNames({
      ...props,
      iconButton,
      disabled,
      isLoading
    })
  };
  return <Component {...componentProps} ref={ref} aria-label={ariaLabel} id={id}>
        {isLoading && <Loader color="cyan" size="sm" />}
        {!isLoading && beforeIcon && <span className="ui__button__before-icon">{beforeIcon}</span>}
        {!(iconButton && isLoading) && children && <span className="ui__button__content">{children}</span>}
        {afterIcon && <span className="ui__button__after-icon">{afterIcon}</span>}
      </Component>;
});
Button.displayName = 'Button';
Button.defaultProps = {
  as: 'button',
  variant: 'contained',
  size: 'middle',
  radius: 'round'
};
export default Button;